/**
 * Implemented to support hammerjs touches in combination with the svg library
 */

var Hammer = require('hammerjs')
;(function () {
  // creates handler, saves it
  function HammerHandler (el) {
    el.remember('_hammer', this)
    this.el = el
  }

  // Sets new parameter, starts dragging
  HammerHandler.prototype.init = function () {
    var _this = this

    var mc = new Hammer.Manager(this.el.node)

    mc.add(new Hammer.Tap())
    mc.add(new Hammer.Pan())

    mc.on('tap', function (e) { _this.onTap(e) })
    mc.on('panmove panend panstart', function (e) { _this.onPan(e) })

  // this.el.on('mousedown.drag', function(e){ _this.start(e) })
  // this.el.on('touchstart.drag', function(e){ _this.start(e) })
  }

  HammerHandler.prototype.onTap = function () {
    var _this = this
    _this.el.fire('tap', {})
  }
  HammerHandler.prototype.onPan = function (e) {
    var _this = this
  
    if (e.type == 'panend') {
      _this.el.fire('panend', e.center)

    } else {
      _this.el.fire('pan', e.center)

    }

  }

  /**
   * Apply the hammerhandler on the draggable element
   */
  SVG.extend(SVG.Element, {
    hammer: function () {
      var hammerHandler = this.remember('_draggable') || new HammerHandler(this)

      // When no parameter is given, value is true
      var value = typeof value === 'undefined' ? true : value

      hammerHandler.init()

      return this
    }

  })
}).call(this)



// WEBPACK FOOTER //
// ./js/components/routine-composer/composer/svg.hammer.js